import React from 'react';
import { Box, Text } from 'components/ui';
import { getText } from 'components/ProductPage/ProductCompareTool/ProductCompareToolItem/compareItemLocale';
import { styles } from 'components/ProductPage/ProductCompareTool/ProductCompareToolItem/compareItemStyles';

export const renderPriceCell = ({ sku, index }) => {
    const valuePrice = sku?.valuePrice
        ? sku.valuePrice
            .toLowerCase()
            .replace(getText('value'), '')
            .replace(/[\(\)]+/g, '')
            .trim()
        : null;

    return (
        <Box
            key={`price-${index}`}
            backgroundColor={index === 0 && 'nearWhite'}
            borderLeftWidth={index > 0 && 1}
            borderColor={index > 0 && 'divider'}
            borderTopColor='transparent'
            paddingLeft={4}
            paddingRight={4}
        >
            <div css={[styles.cell, styles.cellPrice]}>
                <>
                    <Text fontWeight='bold'>
                        {sku.salePrice && (
                            <>
                                <Text
                                    color='red'
                                    children={sku.salePrice}
                                />{' '}
                            </>
                        )}
                        <span
                            css={sku.salePrice && styles.priceList}
                            children={sku.listPrice}
                        />
                    </Text>
                    {valuePrice && <Text is='p'>{`(${valuePrice} ${getText('value')})`}</Text>}
                </>
            </div>
        </Box>
    );
};
